var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 bg-primary text-center text-white"},[_c('span',{staticClass:"text-break",staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }